import React from 'react';
import { useSearch } from '../contexts/SearchContext';
import './PropertyTypeCounter.css';

export default function PropertyTypeCounter() {
  const { properties, investmentData } = useSearch();

  // Calculate status counts and get status icons
  const getStatusData = () => {
    if (!properties || properties.length === 0) {
      return { available: { count: 0, icon: null }, reserved: { count: 0, icon: null }, sold: { count: 0, icon: null } };
    }

    const statusData = { 
      available: { count: 0, icon: null }, 
      reserved: { count: 0, icon: null }, 
      sold: { count: 0, icon: null } 
    };
    
    properties.forEach(property => {
      const status = property.status?.code || 'unknown';
      const icon = property.status?.icon;
      
      if (status === 'available') {
        statusData.available.count++;
        if (!statusData.available.icon && icon) {
          statusData.available.icon = icon;
        }
      } else if (status === 'reserved') {
        statusData.reserved.count++;
        if (!statusData.reserved.icon && icon) {
          statusData.reserved.icon = icon;
        }
      } else if (status === 'sold') {
        statusData.sold.count++;
        if (!statusData.sold.icon && icon) {
          statusData.sold.icon = icon;
        }
      }
    });

    // Dodaj przesunięcie licznika sprzedanych lokali jeśli skonfigurowane
    // (np. dla lokali sprzedanych przed uruchomieniem systemu)
    const soldCountOffset = investmentData?.sold_count_offset || 0;
    statusData.sold.count = Math.max(0, statusData.sold.count + soldCountOffset);

    return statusData;
  };

  const statusData = getStatusData();

  // Don't render if no properties
  if (!properties || properties.length === 0) {
    return null;
  }

  const statusLabels = {
    available: 'Dostępne',
    reserved: 'Zarezerwowane', 
    sold: 'Sprzedane'
  };

  return (
    <div className="property-status-counter">
      <div className="status-items">
        {Object.entries(statusData).map(([statusCode, data]) => (
          <div key={statusCode} className="status-item">
            {data.icon ? (
              <img src={data.icon} alt={statusLabels[statusCode]} className="status-icon" />
            ) : (
              <div className={`status-dot ${statusCode}`}></div>
            )}
            <span className="status-label">{statusLabels[statusCode]} ({data.count})</span>
          </div>
        ))}
      </div>
    </div>
  );
}